import './css/App.css';
import { getAuth,  onAuthStateChanged} from 'firebase/auth';
import { useEffect, useState } from 'react';
import { getDatabase, ref, child, get, onValue } from "firebase/database";
import { useNavigate } from 'react-router-dom';
import DashboardOptionMenu from './components/dashboard/DashboardOptionMenu';

import "./css/Dashboard.css";


import InfoToast from './components/InfoToast';
import Navbar from './components/Navbar';
import NewTask from './components/NewTask';
import Task from './components/dashboard/Task';
import SignOutButton from './components/SignOutButton';
import { getSubjects } from './backend';



import EmptyOptionMenu from "./components/EmptyOptionMenu";

function Dashboard() {
    const auth = getAuth();

    const [email, setEmail] = useState(null);
    const [user, setUser] = useState(null);
    const [tasks, setTasks] = useState(null);
    const [sortingMode, setSortingMode] = useState(null);

    const navigate = useNavigate();

    const [subjects, setSubjects] = useState(null);
    

    // Compute sorted tasks from the raw tasks object + sortingMode
    function getSortedTasks() {
        if (!tasks || typeof tasks !== "object") return [];

        const compareValues = (valueA, valueB) => {
            return String(valueA ?? "").localeCompare(String(valueB ?? ""));
        };

        const entries = Object.entries(tasks).filter(([, value]) => !value?.done);

        if (sortingMode === 1 || sortingMode === 2) { // modus 2: Aufsteigend nach Enddatum, modus 3: absteigend
            entries.sort(([, taskA], [, taskB]) => {
                return compareValues(taskA?.due, taskB?.due);
            });

            if (sortingMode === 2) {
                entries.reverse();
            }
        } 
        if (sortingMode === 3) { // nach fach
            entries.sort(([, taskA], [, taskB]) => {
                return compareValues(taskA?.subject, taskB?.subject);
            });
        }


        return entries;
    }

    useEffect(() => {
        let unsubTasks = null;
        let unsubSorting = null;

        const unsubscribe = onAuthStateChanged(auth, (user) => {
            // Clean up previous onValue listeners when auth state changes
            if (unsubTasks) { unsubTasks(); unsubTasks = null; }
            if (unsubSorting) { unsubSorting(); unsubSorting = null; }

            if (user) {
                setEmail(user.email);
                setUser(user);

                getSubjects(user).then(data => {
                    if (data) {
                        setSubjects(data);
                        localStorage.setItem("planerSubjects", JSON.stringify(data));
                    }
                });
                

                const dbRef = ref(getDatabase());
                get(child(dbRef, `userdata/${user.uid}`)).then((snapshot) => {
                    if (snapshot.exists()) {
                        setTasks(snapshot.val().tasks);
                        setSortingMode(snapshot.val().preferences?.sortingMode);
                    } else {
                        setTasks({});
                    }
                }).catch((error) => {
                    console.error(error);
                });

                const taskPollingRef = ref(getDatabase(), `userdata/${user.uid}/tasks/`);

                unsubTasks = onValue(taskPollingRef, (snapshot) => {
                    const data = snapshot.val();
                    setTasks(data);
                });

                const sortingPollingRef = ref(getDatabase(), `userdata/${user.uid}/preferences/sortingMode`);

                unsubSorting = onValue(sortingPollingRef, (snapshot) => {
                    const newMode = snapshot.val();
                    setSortingMode(newMode);
                });

            } else {
                setEmail(null);
                setUser(null);
                setTasks(null);
                navigate("/login");
            }
        });

        return () => {
            // Clean up all listeners on unmount
            unsubscribe();
            if (unsubTasks) unsubTasks();
            if (unsubSorting) unsubSorting();
        };
    }, [auth]);



    if (email === null ) {
        return (
        <> 
            
            <div className="container-xxl my-3 px-3">
                <div className="spinner-border" role="status">
                    <span className="sr-only"></span>
                </div>
            </div>
            
        </>);
    }

    const sortedTasks = getSortedTasks();

    return (
    <>
    <div className="container-xxl my-3 px-3">
        <button className="btn btn-primary btn-lg" data-bs-toggle="modal" data-bs-target="#newTaskModal">Neue Aufgabe</button>
    </div>
    <div className="container-xxl my-3 d-flex flex-row flex-wrap" data-masonry='{"percentPosition": true, "columnWidth": 200, "itemSelector": ".grid-item"}'>
        {
            subjects && sortedTasks.map(([key, value]) => (
                <Task key={key} name={value.title} id={key} due={value.due} category={value.subject} desc={value.task} />
            ))
        }
        {sortedTasks && sortedTasks.length === 0 ? "Alles erledigt :)" : ""}
    
    </div>
    </>
    );
}

export default Dashboard;
